import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  liveScoreStatus: [],
};

export const liveScoreStatusSlice = createSlice({
  name: 'liveScoreStatus',
  initialState,
  reducers: {
    aGetLiveScoreStatusSuccess: (state, action) => {
      state.liveScoreStatus = action.payload.liveScoreStatus;
    },
    aClearLiveScoreStatus: (state) => {
      state.liveScoreStatus = [];
    },
  },
});

export const {
  aGetLiveScoreStatusSuccess,
  aClearLiveScoreStatus,
} = liveScoreStatusSlice.actions;

export default liveScoreStatusSlice.reducer;
